import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import BannerEnum from '../../enumerators/banner.enum'
import HomeEnum from '../../enumerators/home.enum'

export default class SlidersComponent {
    constructor() {
        SlidersComponent.banner()
        SlidersComponent.travel()
        SlidersComponent.blog()
        SlidersComponent.escape()
        SlidersComponent.event()
    }

    static async banner() {
        if ($(HomeEnum.SLIDER_BANNER).length > 0) {
            SlidersComponent.addSwiperClass(
                $(HomeEnum.SLIDER_BANNER),
                $(HomeEnum.SLIDER_BANNER_WRAPPER),
                $(HomeEnum.SLIDER_BANNER_ITEM),
            )

            const bannerSwiperOptions = {
                mousewheel: false,
                allowTouchMove: true,
                slidesPerView: 1,
                loop: false,
                speed: 1500,
                autoplay: {
                    delay: 6000,
                },
                navigation: {
                    nextEl: '#swiper-banner-next',
                    prevEl: '#swiper-banner-prev',
                },
                lazy: {
                    loadPrevNext: true,
                },
                watchSlidesProgress: true,
                on: {
                    autoplayStart: () => {
                        $(BannerEnum.SLIDER_PROGRESS).each(function () {
                            $(this).css(
                                '--banner-animation',
                                `vertical-progress ${bannerSwiperOptions.autoplay.delay}ms linear forwards`,
                            )
                        })
                    },
                    transitionEnd: () => {
                        if (homeBanner.autoplay.running) {
                            $(BannerEnum.SLIDER_PROGRESS).each(function () {
                                const $this = $(this)
                                setTimeout(() => {
                                    $this.css(
                                        '--banner-animation',
                                        `vertical-progress ${bannerSwiperOptions.autoplay.delay}ms linear forwards`,
                                    )
                                }, 1)
                            })
                        }
                    },
                    setTranslate: () => {
                        $(BannerEnum.SLIDER_PROGRESS).each(function () {
                            $(this).css(
                                '--banner-animation',
                                `vertical-progress-reset ${homeBanner.params.speed}ms ease-in-out forwards`,
                            )
                        })
                    },
                },
            }

            const homeBanner = await Swiper.create(HomeEnum.SLIDER_BANNER, bannerSwiperOptions)
        }
    }

    static async travel() {
        if (
            $(HomeEnum.SLIDER_TRAVEL).length > 0 &&
            window.matchMedia('(min-width: 1001px)').matches
        ) {
            SlidersComponent.addSwiperClass(
                $(HomeEnum.SLIDER_TRAVEL),
                $(HomeEnum.SLIDER_TRAVEL_WRAPPER),
                $(HomeEnum.SLIDER_TRAVEL_ITEM),
            )

            const travelSlider = await Swiper.create(HomeEnum.SLIDER_TRAVEL, {
                mousewheel: false,
                allowTouchMove: true,
                slidesPerView: 1,
                spaceBetween: 40,
                loop: false,
                speed: 1000,
                autoplay: false,
                lazy: {
                    loadPrevNext: true,
                },
                watchSlidesProgress: true,
                pagination: {
                    el: HomeEnum.SLIDER_TRAVEL_PAGINATION,
                    clickable: true,
                    modifierClass: 'customer-',
                    bulletClass: 'customer-pagination-bullet',
                    bulletActiveClass: 'customer-pagination-bullet-active',
                    renderBullet: (index, className) => {
                        const bulletIndex = index + 1
                        const number = (bulletIndex < 10 ? '0' : '') + bulletIndex
                        return `<span class="customer-slider-pagination__item ${className}"><span class="customer-slider-pagination__item__value">${number}</span></span>`
                    },
                },
                breakpoints: {
                    1456: {
                        spaceBetween: 65,
                    },
                },
            })

            travelSlider.on('slideChange', () => {
                const activeAnchor = $(HomeEnum.SLIDER_TRAVEL_ANCHORS).find(
                    `[data-index="${travelSlider.activeIndex}"]`,
                )
                $(HomeEnum.SLIDER_TRAVEL_ANCHOR).removeClass('active')
                $(activeAnchor).addClass('active')
            })

            $(HomeEnum.SLIDER_TRAVEL_ANCHOR).on('click', function () {
                travelSlider.slideTo($(this).data('index'))
            })
        }
    }

    static async blog() {
        if ($(HomeEnum.SLIDER_BLOG).length > 0) {
            SlidersComponent.addSwiperClass(
                $(HomeEnum.SLIDER_BLOG),
                $(HomeEnum.SLIDER_BLOG_WRAPPER),
                $(HomeEnum.SLIDER_BLOG_ITEM),
            )

            const blogSlider = await Swiper.create(HomeEnum.SLIDER_BLOG, {
                mousewheel: false,
                allowTouchMove: true,
                slidesPerView: 1,
                spaceBetween: 15,
                loop: false,
                speed: 1000,
                autoplay: false,
                lazy: {
                    loadPrevNext: true,
                },
                watchSlidesProgress: true,
                pagination: {
                    el: HomeEnum.SLIDER_BLOG_PAGINATION,
                    clickable: true,
                    modifierClass: 'customer-',
                    bulletClass: 'customer-pagination-bullet',
                    bulletActiveClass: 'customer-pagination-bullet-active',
                    renderBullet: (index, className) => {
                        const bulletIndex = index + 1
                        const number = (bulletIndex < 10 ? '0' : '') + bulletIndex
                        return `<span class="customer-slider-pagination__item ${className}"><span class="customer-slider-pagination__item__value">${number}</span></span>`
                    },
                },
                breakpoints: {
                    651: {
                        slidesPerView: 2,
                        spaceBetween: 25,
                    },
                    1001: {
                        slidesPerView: 2,
                        spaceBetween: 35,
                    },
                },
            })

            $(HomeEnum.SLIDER_BLOG_ANCHOR).on('click', function () {
                if (!$(this).hasClass('active')) {
                    $(HomeEnum.SLIDER_BLOG_ANCHOR).removeClass('active')
                    $(this).addClass('active')
                    $(HomeEnum.WRAPPER_BLOG).addClass('is-loading')

                    $.ajax({
                        url: IRISCollectionTheme.ajaxUrl,
                        data: {
                            action: 'get_strate_blog_slider',
                            datas: {
                                index: $(this).data('index'),
                            },
                        },
                        method: 'POST',
                    }).done((response) => {
                        //Inject items
                        $(HomeEnum.SLIDER_BLOG_WRAPPER).html(response)
                        SlidersComponent.addSwiperClass(
                            $(HomeEnum.SLIDER_BLOG),
                            $(HomeEnum.SLIDER_BLOG_WRAPPER),
                            $(HomeEnum.SLIDER_BLOG_ITEM),
                        )
                        blogSlider.update()
                        $(HomeEnum.WRAPPER_BLOG).removeClass('is-loading')
                    })
                }
            })
        }
    }

    static async escape() {
        if ($(HomeEnum.SLIDER_ESCAPE).length > 0) {
            SlidersComponent.addSwiperClass(
                $(HomeEnum.SLIDER_ESCAPE),
                $(HomeEnum.SLIDER_ESCAPE_WRAPPER),
                $(HomeEnum.SLIDER_ESCAPE_ITEM),
            )

            const escapeSlider = await Swiper.create(HomeEnum.SLIDER_ESCAPE, {
                mousewheel: false,
                allowTouchMove: true,
                slidesPerView: 1.45,
                spaceBetween: 15,
                loop: false,
                speed: 1000,
                autoplay: false,
                lazy: {
                    loadPrevNext: true,
                },
                watchSlidesProgress: true,
                pagination: {
                    el: HomeEnum.SLIDER_ESCAPE_PAGINATION,
                    clickable: true,
                    modifierClass: 'customer-',
                    bulletClass: 'customer-pagination-bullet',
                    bulletActiveClass: 'customer-pagination-bullet-active',
                    renderBullet: (index, className) => {
                        const bulletIndex = index + 1
                        const number = (bulletIndex < 10 ? '0' : '') + bulletIndex
                        return `<span class="customer-slider-pagination__item ${className}"><span class="customer-slider-pagination__item__value">${number}</span></span>`
                    },
                },
                breakpoints: {
                    651: {
                        slidesPerView: 2,
                        spaceBetween: 25,
                    },
                    1456: {
                        slidesPerView: 2,
                        spaceBetween: 45,
                    },
                },
            })
        }
    }

    static async event() {
        if ($(HomeEnum.SLIDER_AGENDA).length > 0) {
            SlidersComponent.addSwiperClass(
                $(HomeEnum.SLIDER_AGENDA),
                $(HomeEnum.SLIDER_AGENDA_WRAPPER),
                $(HomeEnum.SLIDER_AGENDA_ITEM),
            )

            const eventSlider = await Swiper.create(HomeEnum.SLIDER_AGENDA, {
                mousewheel: false,
                allowTouchMove: true,
                slidesPerView: 1,
                spaceBetween: 15,
                loop: false,
                speed: 1000,
                autoplay: false,
                lazy: {
                    loadPrevNext: true,
                },
                watchSlidesProgress: true,
                pagination: {
                    el: HomeEnum.SLIDER_AGENDA_PAGINATION,
                    clickable: true,
                    modifierClass: 'customer-',
                    bulletClass: 'customer-pagination-bullet',
                    bulletActiveClass: 'customer-pagination-bullet-active',
                    renderBullet: (index, className) => {
                        const bulletIndex = index + 1
                        const number = (bulletIndex < 10 ? '0' : '') + bulletIndex
                        return `<span class="customer-slider-pagination__item ${className}"><span class="customer-slider-pagination__item__value">${number}</span></span>`
                    },
                },
                breakpoints: {
                    651: {
                        spaceBetween: 25,
                    },
                    1001: {
                        spaceBetween: 0,
                    },
                },
            })
        }
    }

    /**
     *
     * @param container
     * @param wrapper
     * @param item
     */
    static addSwiperClass(container, wrapper, item) {
        $(container).addClass('swiper-container')
        $(wrapper).addClass('swiper-wrapper')
        $(item).addClass('swiper-slide')
    }
}
